import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLOptGroupElement extends HTMLElement { constructor(tagName: string = 'OPTGROUP', ownerDocument?: any) { super(tagName, ownerDocument); } }
